import { Model } from "vue-mc";

import { equal, integer, min, required, string } from "vue-mc/validation";
import Rendered from "./Rendered";
import BlogMedia from "./BlogMedia";
import { WP_LINKS } from "@/plugins/Constants";

class BlogPost extends Model {
  options() {
    return {
      editable: true,
    };
  }

  defaults() {
    return {
      id: 0,
      date: null,
      guid: null,
      link: null,
      content: new Rendered(),
      excerpt: new Rendered(),
      featured_media: 0,
      media: new BlogMedia(),
      image: WP_LINKS.blogDefault,
    };
  }

  validation() {
    return {
      id: integer.and(min(1)).and(!equal(null)),
      date: required,
      link: string.and(required),
      content: required,
      excerpt: required,
      featured_media: integer.and(required),
    };
  }
}

export default BlogPost;
